export default "__VITE_ASSET__6kh6a9$D__"